// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1G5JV","left":"InfoRow_left__2Vapp"};